module.exports = __webpack_public_path__ + "img/阴.207e4789.png";